import { CREATION_CLEAR_SEARCH, CREATION_SEARCH_TEMPLATES } from '../../../../ActionsConst';
import type { Action } from '../../../../ActionsConst';

export type SearchAction = Action & {
  search: {
    templateSearch: string,
    isLoading: boolean,
    total: number,
  },
};

export const clearSearch = (): Action => ({
  type: CREATION_CLEAR_SEARCH,
});

export const searchTemplatesAction = (searchTerm: string): SearchAction => ({
  type: CREATION_SEARCH_TEMPLATES,
  search: {
    templateSearch: searchTerm,
    isLoading: true,
    total: 0,
  },
});
